<template>
  <!-- Main event table container - make it fixed height and prevent overall scrolling -->
  <!-- <div class="flex flex-row h-full items-end"> -->
    

    <!-- Main table container - fixed height with internal scrolling -->
    <!-- <div class="flex flex-col flex-1 h-full "> -->
      
      <!-- Main content -->
      <div class="flex flex-row h-full items-end" ref="mainContent">
          <!-- Main table container, which includes the search bar, table actions, filters and event rows -->
          <div 
            :class="[
              'flex flex-col bg-white h-full ',
              store.showSubscriptionsDialog ? 'flex-1' : 'w-10/12 mx-auto'
              ]"
            @contextmenu.prevent="handleRightClick">

            <!-- Search Bar -->
            <div class="flex flex-row items-center justify-center">
              <i 
              :class="[
                'fa-solid fa-tower-broadcast text-gray-400 text-lg self-start mt-2 mr-2',
                animateTowerBroadcast ? 'animate-pulse' : ''
              ]" 
              v-tippy="{ content: 'New events that match the search criteria will be added automatically to your watchlist' }"
              />
            <SearchBar ref="searchBar" :showTitle="false" class="self-center mb-4" @refetch-events-for-watchlist="refetchEventsForWatchlist" />
            </div>


            <!-- Table Container for border -->
            <div class="h-full border border-gray-300 rounded-lg shadow-lg overflow-y-hidden">
              <!-- Header buttons -->
              <div class="flex text-lg font-light justify-between p-2 sticky top-0  bg-white z-10">

                <!-- Watchlist Alert Buttons -->
                <div class="flex flex-row items-center justify-start">

                  <!-- Show Alerts Button -->
                  <button
                    v-if="size(store.currentWatchListId) > 0 && size(store.nevuaSubscriptions) > 0 && store.nevuaSubscriptions.some(sub => sub.watchlistId === store.currentWatchListId)"
                    class="flex items-center justify-center hover:border-gray-300 border border-transparent rounded-md px-2 py-1 mr-2 "
                    @click="listAlertsAndCreateAlert({ scope: SubscriptionScope.WATCHLIST, event: null, market: null, watchlistId: store.currentWatchListId })"
                    v-tippy="{ content: 'View all alerts in this watchlist' }">
                    <i v-if="store.nevuaSubscriptions.some(sub => sub.watchlistId === store.currentWatchListId && sub.status.enabled)" class="fas fa-bell text-gray-600 hover:text-gray-800"></i>
                    <i v-else class="fas fa-bell-slash text-gray-600 hover:text-gray-800"></i>

                    <span class="font-thin ml-1">View Alerts</span>
                  </button>
                </div>
                
                <!-- Filter Actions -->
                  <div class="flex flex-row items-center justify-between">
                  <div class="flex relative mr-2">
                    <input data-search-input v-model="searchText" type="text" placeholder="Filter by title"
                    class="w-50 px-3 py-1 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" />
                    <button 
                      v-if="searchText"
                      @click="searchText = ''">
                    <i 
                      class="fas fa-times absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                      >
                    </i>
                    </button>
                  </div>
                  <TableFilterMenu v-if="size(store?.currentWatchListId) > 0" class="relative mr-2"
                    :watch-list="store?.currentWatchList" @toggle-expand-all="toggleExpandAll"
                    @toggle-show-closed="toggleShowClosedItems" />
                  <TableColumnSelection class="relative "
                    :columns="store.columns"
                    @toggle-column="toggleColumnVisibility" />
                  </div>
              </div>

              <div v-if="loading" class="absolute inset-0 flex justify-center items-center z-20">
                <div class="absolute inset-0 bg-white bg-opacity-50 backdrop-blur-sm"></div>
                <div class="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-gray-900 z-30"></div>
              </div>

              <!-- Table -->
              <div class="flex-1 w-full h-full overflow-y-scroll">
                <table class="w-full divide-y divide-gray-200 font-mono text-xs overflow-y-scroll">

                  <!-- Table header -->
                  <thead class="bg-gray-50 sticky top-0">
                    <tr class="">
                      <!-- selection -->
                      <th class="th-class pl-2">
                        <button 
                          class="items-center"
                          @click="toggleSelectAll">
                          <i :class="[
                            ' text-gray-500 hover:text-gray-700 text-base',
                            {
                              'fa-regular fa-square': selectAllState === 'none',
                              'fa-regular fa-square-check': selectAllState === 'all',
                              'fa-regular fa-square-minus': selectAllState === 'some'
                            }
                          ]">
                          </i>
                        </button>
                      </th>
                      <!-- auto fetch -->
                      <!-- <th class="th-class action-col">
                        <div class="items-center justify-center">
                        </div>
                      </th> -->
                      <!-- alerts -->
                      <th class="th-class action-col">
                        <div class="items-center justify-center">
                        </div>
                      </th>
                      <th v-for="column in store.columns.filter(col => col.visible)" :key="column.key" scope="col"
                        :class="['first:pl-4 h-8', getColumnWidthClass(column.key)]">
                        <div class="flex items-center h-8 w-full">
                          <a v-if="column.sortable" href="#" 
                            @click="toggleSort(column.key)"
                            class="th-class h-full flex items-center">
                            {{ column.label }}
                            <img :src="getSortIcon(column.key)" class="inline-block h-4 "
                              alt="Sort Icon" />
                          </a>
                          <span v-else class="th-class h-full flex items-center">
                            {{ column.label }}
                          </span>
                          <div v-if="column.key === 'title'" class="relative flex-1 h-full">
                            <button v-if="hasSelectedRows" @click.stop="showBulkActionsMenu($event)" ref="bulkActionsButton"
                              data-bulk-actions
                              class="absolute top-0 bottom-0 flex items-center justify-center border bg-white shadow-sm hover:bg-gray-100 rounded-md px-3 text-xs font-sans font-normal">
                              Bulk actions ...
                            </button>
                          </div>
                        </div>
                      </th>
                    </tr>
                  </thead>

                  <!-- Table contents / rows -->
                  <tbody class="bg-white divide-y divide-gray-200 overflow-y-scroll">
                    <tr v-for="({ event, market, isParentRow, rowKey }, index) in flattenedEvents" :key="rowKey"
                      :id="rowKey" :class="[
                        store.tableState.updatedRowKeys[rowKey] ? 'animate-pulse' : '',
                        isParentRow ? 'h-12' : 'h-12',
                        'ml-2',
                        {
                          'hover:bg-gray-100': !contextMenu.show,
                          'bg-gray-300': contextMenu.show && contextMenu.selectedRowId === rowKey,
                        }
                      ]" tabindex="0" v-show="isParentRow || (
                          (!event.nevuaMultipleMarkets || store.tableState.multiMarketEvents[event.id]?.expanded) &&
                          isMarketVisible(event.id, market.id)
                        )" class="group">

                      <!-- selection -->
                      <td class="action-col pl-2">
                        <button 
                          class="items-center"
                          @click="(e) => handleRowSelection({ target: { checked: !isRowSelected(event, market, isParentRow) } }, event, market, isParentRow)">
                          <i 
                            :class="[
                              'text-base',
                              {
                                'opacity-0 group-hover:opacity-100': !isRowSelected(event, market, isParentRow) && !(isParentRow && isParentPartiallySelected(event)),
                                'fa-regular fa-square': !isRowSelected(event, market, isParentRow) && !(isParentRow && isParentPartiallySelected(event)),
                                'fa-regular fa-square-check': (isParentRow && areAllMarketsSelected(event)) || (!isParentRow && isRowSelected(event, market, isParentRow)),
                                'fa-regular fa-square-minus': isParentRow && isParentPartiallySelected(event)
                              }
                            ]">
                          </i>
                        </button>
                      </td>

                      <!-- alerts -->
                      <td class="action-col">
                        <div class="items-center justify-center">

                          <!-- View Event Alerts -->
                          <button v-if="isParentRow && size(event.nevuaSubscriptions) > 0"
                            @click="listAlertsAndCreateAlert({ scope: SubscriptionScope.EVENT, event, market: null, watchlistId: store?.currentWatchListId })"
                            v-tippy="{ content: 'View alerts specific to this event' }"
                            class="flex items-center justify-center text-xs hover:border-gray-300 border border-transparent rounded-md p-1 text-gray-600 hover:text-gray-800">
                            <i v-if="event.nevuaSubscriptions.some(sub => sub.status.enabled)"
                              class="fas fa-bell text-xs"></i>
                            <i v-else class="fas fa-bell-slash text-gray-600 hover:text-gray-800 text-xs "></i>
                          </button>

                          <!-- Create Event Alert -->
                          <button v-if="isParentRow && size(event.nevuaSubscriptions) === 0 && event.closed === false && event.active === true"
                            @click="handleCreateAlert(SubscriptionScope.EVENT, event, null)"
                            v-tippy="{ content: 'Create an alert for this event only' }"
                            class="flex items-center justify-center text-xs hover:border-gray-300 border border-transparent rounded-md opacity-0 group-hover:opacity-100 text-gray-600 hover:text-gray-800 p-1">
                            
                            <img src="/assets/bell-plus.svg" class="w-4 h-4"></img>
                          </button>

                          <!-- View Market Alerts -->
                          <button v-if="!isParentRow && size(market.nevuaSubscriptions) > 0"
                            @click="listAlertsAndCreateAlert({ scope: SubscriptionScope.MARKET, event, market, watchlistId: store?.currentWatchListId })"
                            v-tippy="{ content: 'View alerts specific to this market' }"
                            class="flex items-center justify-center text-xs hover:border-gray-300 border border-transparent rounded-md  text-gray-600 hover:text-gray-800 p-1">
                            <i v-if="market.nevuaSubscriptions.some(sub => sub.status.enabled)"
                              class="fas fa-bell text-xs "></i>
                            <i v-else class="fas fa-bell-slash text-gray-600 hover:text-gray-800 text-xs "></i>
                          </button>

                          <!-- Create Market Alert -->
                          <button v-if="!isParentRow && size(market.nevuaSubscriptions) === 0 && market.closed === false && market.active === true"
                            @click="handleCreateAlert(SubscriptionScope.MARKET, event, market)"
                            v-tippy="{ content: 'Create an alert for this market only', placement: 'bottom' }"
                            class="flex items-center justify-center text-xs hover:border-gray-300 border border-transparent rounded-md opacity-0 group-hover:opacity-100 text-gray-600 hover:text-gray-800 p-1">
                            
                            <img src="/assets/bell-plus.svg" class="w-4 h-4"></img>
                          </button>
                        </div>
                      </td>

                      <td v-for="column in store.columns.filter(col => col.visible)" :key="column.key"
                        :class="['mr-6 first:pl-4', getColumnWidthClass(column.key)]">

                        <!-- title column -->
                        <div v-if="column.key === 'title'"
                          class="items-center text-xs pr-4 space-x-2 flex flex-row">
                          <!-- <div class="flex items-center min-w-0 break-words"> -->

                            <!-- Chevron icon for parent row-->
                            <button v-if="isParentRow" @click.stop="toggleExpanded(event.id)">
                            <i :class="[
                              'fas fa-sm fa-chevron-right mr-2',
                              'transition-transform duration-300',
                              store.tableState.multiMarketEvents[event.id]?.expanded ? 'rotate-90' : ''
                            ]" />
                            </button>
        
                            <!-- Event title -->
                            <button v-if="isParentRow"
                              class="text-left min-w-0"
                              @click.stop="toggleExpanded(event.id)"
                              v-tippy="{ content: 'This event contains multiple markets. Tap to view.' }" v-html="getEventTitle(event, null)" />
                            <span v-else 
                              :class="event.nevuaMultipleMarkets && !isParentRow ? '' : ''" 
                              v-html="getEventTitle(event, market, isParentRow)" />


                            <!-- Auto fetch icon -->
                            <!-- <div class="items-center justify-center mx-1"> -->
                            <!-- <i 
                              v-show="isParentRow
                                  && store?.currentWatchList?.events?.[event.id]?.autoFetch
                                  && !event.closed"
                              v-tippy="{ content: 'New markets associated with this event will be added automatically.'}" class="fas fa-circle text-gray-400 hover:text-gray-700" /> -->

                            <Tippy
                              v-show="isParentRow && store?.currentWatchList?.events?.[event.id]?.autoFetch == false && !event.closed"
                              :interactive="true"
                              placement="bottom">
                              <template #content>
                                <div class="flex flex-col font-sans font-normal">
                                  <div class="text-sm">New markets associated with this event will be added automatically
                                    <strong>only if they match the watchlist query</strong>.</div>

                                  <button class="bg-blue-100 hover:bg-blue-200 text-gray-600 text-sm px-3 py-1 mt-2 rounded"
                                    @click="handleAddAllMarkets(event.id)">
                                    Track <strong> all </strong> markets for this event instead
                                  </button>
                                </div>
                              </template>
                              <i class="fas fa-circle-half-stroke text-orange-300 hover:text-orange-500"></i>
                            </Tippy>
                            <!-- </div> -->

                            <!-- Polymarket link -->
                            <a :href="`https://polymarket.com/event/${event.slug}`" target="_blank"
                              class="opacity-0 group-hover:opacity-100 transition-opacity duration-150"
                              @click.stop tabindex="-1">
                              <i class="fas fa-link text-blue-500 hover:text-blue-700" 
                                v-tippy="{ content: 'View on Polymarket', placement: 'bottom' }" />
                            </a>
                          
                            <!-- Move ellipsis here (after the link) -->
                            <button class="fas fa-ellipsis-h opacity-0 group-hover:opacity-100 hover:text-gray-700 hover:border-gray-300 border border-transparent rounded-md px-1 text-xs hover:bg-gray-100"
                              @click.stop="showContextMenu($event, event, market, isParentRow, rowKey)" 
                              v-tippy="{ content: 'Actions', placement: 'bottom' }" />
                          
                            <span 
                              v-if="isAddingAllMarkets && contextMenu.selectedEvent?.id === event.id && isParentRow"
                              class="ml-2 inline-block flex-shrink-0">
                              <div class="animate-spin rounded-full h-3 w-3 border-t-2 border-b-2 border-gray-900"></div>
                            </span>
                          <!-- </div> -->
                        </div>

                        <!-- Trend column -->
                        <div v-if="column.key === 'trend'">
                          <div class="">
                            <button 
                              @click="handleSvgClick(event.id, market.id, market.question, event.slug, market.clobTokenIds ? JSON.parse(market.clobTokenIds)[0] : null, market.createdAt)"
                              v-html="getColumnValue({ event, market, isParentRow }, column.key)"
                              v-tippy="{ content: !isParentRow ? 'Expand graph' : undefined }"
                              class="w-full h-full"
                            >
                            </button>
                            <div v-if="!isParentRow" class="absolute inset-0 w-full flex justify-start pl-10 items-center opacity-0 group-hover:opacity-50 pointer-events-none">
                              <i class="fa-solid fa-up-right-and-down-left-from-center text-gray-800 text-lg text-center"></i>
                            </div>
                          </div>
                        </div>

                        <!-- other columns -->
                        <div v-else>
                          <div v-if="columnTooltips[column.key]"
                            v-tippy="{ content: columnTooltips[column.key]({ event, market, isParentRow }) }">
                            <span :class="{ 'font-normal': column.key === 'volume' }"
                              v-html="getColumnValue({ event, market, isParentRow }, column.key)">
                            </span>
                          </div>
                          <span v-else
                            :class="{ 'font-normal': column.key === 'volume'  }"
                            class="text-xs break-words" v-html="getColumnValue({ event, market, isParentRow }, column.key)">
                          </span>
                        </div>
                      </td>
                    </tr>
                    <!-- Add empty row to ensure context menu is visible when scrolled to bottom -->
                    <tr class="h-20"></tr>
                  </tbody>
                  <!-- </transition-group> -->
                </table>
                <!-- subscription dialog -->
              </div>
            </div>
          </div>

          <!-- Subscription Dialog Panel -->
          <!-- h-5/6 to limit height h-[93%]-->
          <div v-if="store.showSubscriptionsDialog" class="w-4/12 border-2 rounded-lg  h-[90%] overflow-hidden" >
            <SubscriptionsDialogContent ref="subscriptionsDialog" 
              :is-open="store.showSubscriptionsDialog" 
              :scope="store.subscriptionScope" 
              :target-title="store.subscriptionTargetTitle" 
              :current-watchlist="store.currentWatchList"
              :events-to-create-alert-for="store.eventsToCreateAlertFor" 
              :list-alerts-for-market-id="store.listAlertsForMarketId"
              :list-alerts-for-event-id="store.listAlertsForEventId" 
              :list-alerts-for-watchlist-id="store.listAlertsForWatchlistId"
              :subscription-to-edit="store.subscriptionToEdit" 
              :show-alert-list-tab-first="store.showAlertListTabFirst"
              :price="store.subscriptionPrice"
              @close="handleCloseSubscriptionsDialog" 
              @delete="handleSubscriptionDelete" 
              @edit="handleSubscriptionEdit"
              @clear-filters="clearAlertFilters" 
              class="h-full overflow-auto" 
            />
          </div>
      </div>
      
      <!-- Context Menu -->
      <ContextMenu v-if="contextMenu?.show" :position="{ x: contextMenu.x, y: contextMenu.y }"
              :is-bulk-action="contextMenu.isBulkAction" :watch-lists="store.watchLists"
              :is-parent-row="contextMenu.isParentRow" :should-show-add-all-markets="shouldShowAddAllMarketsOption"
              :is-watch-list="size(store.currentWatchListId) > 0" :current-watch-list="store.currentWatchList"
              :is-active="contextMenu.isActive" @set-trend-alert="handleCreateAlertFromContextMenu"
              @add-to-table="addItemsToExistingWatchList" @create-new-table="createNewWatchListWithSelectedItems"
              @remove-from-list="removeFromList" @add-all-markets="handleAddAllMarkets" />

      <!-- Subscription Delete Confirmation Modal -->
      <TransitionRoot appear :show="store.isSubscriptionDeleteModalOpen" as="template">
        <Dialog as="div" class="relative z-50">
          <div class="fixed inset-0 bg-black/30" />
          <div class="fixed inset-0 overflow-y-auto">
            <div class="flex min-h-full items-center justify-center p-4">
              <DialogPanel class="w-full max-w-md rounded-lg bg-white p-6">
                <DialogTitle class="text-lg font-medium mb-4">Confirm Deletion</DialogTitle>
                <p class="mb-6">Are you sure you want to delete this alert? This action cannot be undone.</p>
                <div class="flex justify-end space-x-3">
                  <button @click="closeSubscriptionDeleteModal"
                    class="px-4 py-2 rounded-lg bg-gray-100 hover:bg-gray-200">
                    Cancel
                  </button>
                  <button @click="confirmSubscriptionDelete"
                    class="px-4 py-2 rounded-lg bg-red-500 hover:bg-red-600 text-white">
                    Delete
                  </button>
                </div>
              </DialogPanel>
            </div>
          </div>
        </Dialog>
      </TransitionRoot>
      
      <!-- Floating Graph Modal -->
      <FloatingGraph 
        v-if="activeGraph.show"
        :eventId="activeGraph.eventId"
        :marketId="activeGraph.marketId"
        :clobTokenId="activeGraph.clobTokenId"
        :title="activeGraph.title"
        :eventSlug="activeGraph.eventSlug"
        :marketCreatedAt="activeGraph.marketCreatedAt"
        @close="closeGraph"
        @graph-alert="handleGraphAlert"
      />
</template>

<script>
import {
  Listbox,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
  Dialog,
  DialogPanel,
  DialogTitle,
  TransitionRoot,
  TransitionChild,
} from '@headlessui/vue';
import { useDebounceFn } from '@vueuse/core';
import moment from 'moment';
import { isEmpty, size, filter, has, pickBy, pick, reduce, omit, cloneDeep } from 'lodash';
import { formatDistanceToNowStrict } from 'date-fns';

import { SubscriptionScope } from '../types/Subscriptions';
import apiClient from '../utils/axios';

import TableFilterMenu from './menus/TableFilterMenu.vue'
import TableColumnSelection from './menus/TableColumnSelection.vue'
import ContextMenu from './menus/ContextMenu.vue';
import SubscriptionsDialogContainer from './SubscriptionsDialogContainer.vue';
import SubscriptionsDialogContent from './SubscriptionsDialogContent.vue';
import SearchBar from './SearchBar.vue';

import { Tippy } from 'vue-tippy'

import { RecycleScroller } from 'vue-virtual-scroller'
import FloatingGraph from './FloatingGraph.vue';
import * as Sentry from '@sentry/vue';
import {
  store,
  updateWatchList,
  createWatchListInAPI,
  showDialog,
  removeContextItemsFromList,
  addContextItemsToWatchList,
  createNewWatchListPlaceholderItem,
  deleteSubscriptionFromGlobalStateAndTableState,
  clearAlertFilters,
  clearSubscriptionDialogState,
  handleCreateAlert,
  updatePrices
} from '../store';

export default {
  components: {
    Listbox,
    ListboxButton,
    ListboxOptions,
    ListboxOption,
    ContextMenu,
    SubscriptionsDialogContainer,
    Dialog,
    DialogPanel,
    DialogTitle,
    TransitionRoot,
    TransitionChild,
    TableFilterMenu,
    TableColumnSelection,
    RecycleScroller,
    SubscriptionsDialogContent,
    Tippy,
    SearchBar,
    FloatingGraph
  },
  props: {
    marketName: String,
    marketSlug: String,
    loading: Boolean,
    events: Array,
  },
  emits: ['refetch-events-for-watchlist'],
  watch: {
    '$route.params': {
      handler(newParams, oldParams) {
        this.handleCloseSubscriptionsDialog();
        this.animateTowerBroadcast = true;
        setTimeout(() => {
          this.animateTowerBroadcast = false;
        }, 10000);
      },
      immediate: true
    },
  },
  data() {
    return {
      store,
      animateTowerBroadcast: false,
      SubscriptionScope,
      //selectedColumns: [],
      contextMenu: {
        show: false,
        x: 0,
        y: 0,
        event: null,
        selectedEvent: null,
        selectedMarket: null,
        selectedRowId: null,
        isParentRow: false,
        isBulkAction: false,
      },
      activeGraph: {
        show: false,
        eventId: null,
        marketId: null, 
        marketCreatedAt: null,
        clobTokenId: null,
        eventSlug: null,
        title: ''
      },
      dialogHeight: 600, // Default height

      columnTooltips: {
        lastUpdated: ({ event, market, isParentRow }) => this.formatEpochTimestampAsDateTime(event.nevuaLastUpdatedTimestamp),
        createdAt: ({ event, market, isParentRow }) => isParentRow ? this.formatStringAsDateTime(event.createdAt) : this.formatStringAsDateTime(market.createdAt),
        endDate: ({ event, market, isParentRow }) => {
          if (isParentRow) {
            return this.formatStringAsDateTime(event.endDate)
          } else {
            let endDate = market.endDate || event.endDate;
            return this.formatStringAsDateTime(endDate)
          }
        },
        volume: ({ event, market, isParentRow }) => isParentRow ? "Total volume traded across both active and closed markets." : undefined,
        // Add more column tooltip functions here as needed
      },
      selectedRows: {},



      /* Watchlist Actions */
      isAddingAllMarkets: false,
      isWatchlistDeleteModalOpen: false,

      searchText: '', /* Search markets by name filter */
      debouncedCreateNewWatchListWithSelectedItems: null,
    };
  },
  created() {
    //this.selectedColumns = store.columns.filter(column => column.visible);
    this.debouncedCreateNewWatchListWithSelectedItems = useDebounceFn(async function (watchListName) {
      if (!watchListName) return;

      // Create new sidebar item
      const newWatchList = createNewWatchListPlaceholderItem(watchListName);

      // Add items to the new watchlist
      const itemCount = addContextItemsToWatchList(newWatchList, this.contextMenu, this.selectedRows);

      showDialog({
          message: `Creating new watchlist...`,
          type: 'info',
          timeout: 3000
        });

      // update user settings through api
      let watchListId = await createWatchListInAPI(newWatchList);

      if (watchListId) {
        newWatchList.id = watchListId;
        store.watchLists.unshift(newWatchList);

        // Show success notification
        showDialog({
          message: `Created new watchlist "${watchListName}" with ${itemCount} item${itemCount !== 1 ? 's' : ''}`,
          type: 'success',
          timeout: 3000
        });
      } else {
        showDialog({
          message: `Failed to create watchlist`,
          type: 'error',
          timeout: 3000
        });
      }

      // Reset input and close context menu
      this.resetContextMenuAndSelectedRows();
    }, 2000)
  },
  mounted() {
    document.addEventListener('click', this.handleDocumentClick);
    // Update dialog height after component is mounted
    this.$nextTick(() => {
      this.updateDialogHeight();
    });
  },
  
  beforeUnmount() {
    document.removeEventListener('click', this.handleDocumentClick);
  },
  computed: {
    hasSelectedRows() {
      return Object.values(this.selectedRows).some(v => v);
    },

    selectAllState() {
      const allMarkets = this.flattenedEvents.filter(item => !item.isParentRow);
      const selectedCount = allMarkets.filter(({ event, market }) =>
        this.selectedRows[this.getRowKey(event, market)]
      ).length;
      const totalCount = allMarkets.length;

      if (selectedCount === 0) return 'none';
      if (selectedCount === totalCount) return 'all';
      return 'some';
    },

    shouldShowAddAllMarketsOption() {
      if (!this.contextMenu.isParentRow || !size(store.currentWatchListId) || !this.contextMenu.selectedEvent) {
        return false;
      }

      const eventId = this.contextMenu.selectedEvent.id;
      const eventEntry = store.currentWatchList?.events?.[eventId];

      return !eventEntry?.autoFetch
    },

    flattenedEvents() {
      return store.tableState.events.reduce((acc, event) => {
        // Filter markets based on visibility and closed status
        let filteredMarkets = event.markets.filter(market => {
          if (!market.active) {
            console.warn('Found inactive market', market.id, 'in event', event.id);
          }
          return this.isMarketVisible(event.id, market.id) && market.active
        });

        // Skip if all markets are filtered out
        if (filteredMarkets.length === 0) return acc;

        // First check if event title matches search text
        const eventMatchesSearch = this.searchText === '' ||
          event.title.toLowerCase().includes(this.searchText.toLowerCase());

        // If eventMatchesSearch is true, we want to add all markets, so no filtering
        // If it is false, then filter markets based on search text
        filteredMarkets = eventMatchesSearch ? filteredMarkets : filteredMarkets.filter(market =>
          market.question.toLowerCase().includes(this.searchText.toLowerCase())
        );

        if (filteredMarkets.length === 0) {
          return acc;
        }

        // Add an extra parent row for multi-market events
        if (event.nevuaMultipleMarkets) {
          acc.push({
            event: { ...event, markets: filteredMarkets },
            market: filteredMarkets[0],
            isParentRow: true,
            rowKey: this.getRowKey(event, filteredMarkets[0], true)
          });
        }

        // Add individual market rows
        filteredMarkets.forEach(market => {
          acc.push({
            event: { ...event, markets: filteredMarkets },
            market,
            isParentRow: false,
            rowKey: this.getRowKey(event, market, false)
          });
        });

        return acc;
      }, []);
    },

    isMarketVisible() {
      return (eventId, marketId) => {
        if (isEmpty(store.currentWatchList)) {
          // If no watchlist is selected or it's an empty object, show all markets
          return true
        }
        const watchlistEvent = store.currentWatchList?.events?.[eventId];
        const marketInEvent = watchlistEvent?.markets?.includes(marketId);

        const shouldShowClosed = store.currentWatchList?.tableSettings?.showClosedItems || true;

        // If watchlist exists but event not in watchlist settings, log a warning and hide market
        if (!watchlistEvent || !marketInEvent) {
          return false;
        }

        return shouldShowClosed
      }
    },
  },
  methods: {
    refetchEventsForWatchlist(watchListId) {
      this.$emit('refetch-events-for-watchlist', watchListId);
    },
    /* Subscriptions */
    clearAlertFilters,
    handleCreateAlert,
    size(obj) {
      return size(obj);
    },

    getRowKey(event, market, isParentRow = false) {
      return `${event.id}-${isParentRow ? 'parent' : market.id}`;
    },

    /*
      Document Click Handlers
      ------------------------------------------------------------
    */
    handleDocumentClick(event) {
      const contextMenuEl = document.querySelector('.context-menu');
      const isBulkActionsButton = event.target.closest('[data-bulk-actions]');

      // If bulk action is activated, simply close the context menu without resetting the selected rows
      if (this.contextMenu?.show && this.contextMenu?.isBulkAction && !isBulkActionsButton) {
        console.log('clicked outside bulk actions')
        this.contextMenu.show = false;
        return;
      }

      if (this.contextMenu.show && !contextMenuEl?.contains(event.target)) {
        console.log('clicked outside context menu')
        this.resetContextMenuAndSelectedRows();
      }

      // if clicking outside the serach text input, trim it
      const isSearchInput = event.target.closest('[data-search-input]');
      if (!isSearchInput) {
        this.searchText = this.searchText.trim();
      }
    },

    handleRightClick(event) {
      // Check if click was inside thead
      if (event.target.closest('thead')) {
        return;
      }

      const row = event.target.closest('tr');
      if (!row) {
        return;
      }

      // return `${event.id}-${isParentRow ? 'parent' : market.id}`;

      console.log('Right click context - row id:', row.id);
      //const rowIndex = Array.from(row.parentElement.children).indexOf(row);
      //const rowData = this.flattenedEvents[rowIndex];

      const [eventId, marketId] = row.id.split('-');
      const isParentRow = marketId === 'parent';

      const selectedEvent = store.tableState.events.find(e => e.id === eventId);
      const selectedMarket = selectedEvent.markets.find(m => m.id === marketId);
      const clobTokenId = isParentRow ? null : JSON.parse(selectedMarket.clobTokenIds)[0];

      //if (!rowData) return;

      // Log event and market IDs
      console.log('Right click context - is parent row:', isParentRow, 'Event ID:', eventId, 'Market ID:', !isParentRow ? marketId : null, 'Clob Token ID:', clobTokenId);

      // Show the context menu at the right-click position
      this.resetContextMenuAndSelectedRows();
      this.showContextMenu(
        {
          preventDefault: () => { },
          target: {
            getBoundingClientRect: () => ({
              left: event.clientX,
              right: event.clientX,
              top: event.clientY
            })
          }
        },
        selectedEvent,
        selectedMarket,
        isParentRow,
        row.id,
      );

    },
    /*
      ------------------------------------------------------------
    */

    formattedVolume(volume) {
      let numericVolume = parseFloat(volume);
      if (isNaN(numericVolume)) {
        numericVolume = 0;
      }
      return numericVolume.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 })
    },

    /*
      Time Formatting
      ------------------------------------------------------------
    */
    formatStringAsDate(dateString) {
      if (!dateString) return 'N/A';
      try {
        return moment(dateString).format('MMM DD, YYYY');
      } catch (error) {
        console.warn(`Invalid date format for: ${dateString}`);
        return 'N/A';
      }
    },

    formatStringAsDateTime(dateString) {
      return moment(dateString).format('MMM DD, YYYY HH:mm [GMT]Z');
    },

    formatEpochTimestampAsDateTime(epochTimestamp) {
      return moment.unix(epochTimestamp).format('MMM DD, YYYY HH:mm [GMT]Z');
    },

    formatDistanceToNow(dateString) {
      if (!dateString) return '';
      try {
        return formatDistanceToNowStrict(new Date(dateString), { addSuffix: true });
      } catch (error) {
        console.warn(`Invalid date format for: ${dateString}`);
        return '';
      }
    },
    /*
      ------------------------------------------------------------
    */

    sortEvents() {
      const sortKey = Object.keys(store.tableState.sortOrder).find(key => store.tableState.sortOrder[key]);

      if (!sortKey) {
        return
      }

      const order = store.tableState.sortOrder[sortKey];
      const multiplier = order === 'asc' ? 1 : -1;

      store.tableState.events.sort((eventA, eventB) => {
        switch (sortKey) {
          case 'title':
            return (eventA.title || '').localeCompare(eventB.title || '') * multiplier;
          case 'volume':
            let numericVolumeA = parseFloat(eventA.volume);
            let numericVolumeB = parseFloat(eventB.volume);
            if (isNaN(numericVolumeA)) numericVolumeA = 0;
            if (isNaN(numericVolumeB)) numericVolumeB = 0;
            return (numericVolumeA - numericVolumeB) * multiplier;
          case 'createdAt':
            return (new Date(eventA.createdAt).getTime() - new Date(eventB.createdAt).getTime()) * multiplier;
          case 'endDate':
            return (new Date(eventA.endDate).getTime() - new Date(eventB.endDate).getTime()) * multiplier;
          default:
            return 0;
        }
      });
    },

    toggleSort(column) {
      const currentOrder = store.tableState.sortOrder[column];

      // Reset all sort orders
      Object.keys(store.tableState.sortOrder).forEach(key => {
        store.tableState.sortOrder[key] = null;
      });

      // Toggle the sort order for the current column
      store.tableState.sortOrder[column] = currentOrder === 'asc' ? 'desc' : 'asc';
      //store.tableState.events = this.sortEvents();
      this.sortEvents();

    },

    getSortIcon(column) {
      const basePath = '/assets';
      if (store.tableState.sortOrder[column] === 'asc') {
        return `${basePath}/resize-small-up.svg`;
      } else if (store.tableState.sortOrder[column] === 'desc') {
        return `${basePath}/resize-small-down.svg`;
      }
      return `${basePath}/resize-small.svg`;
    },

    /*
      Title Formatting
      ------------------------------------------------------------
    */
  
    getClosedTitle(title) {
      return `<span class="text-gray-500">${title}</span><span class="text-red-500"> [CLOSED]</span>`;
    },

    getEventTitle(event, market, isParentRow) {
      const isEventClosed = event?.closed || event?.active === false;
      const isMarketClosed = market?.closed || market?.active === false;

      if (!event.nevuaMultipleMarkets || !market) {
        // Single-market event: show event title + closed status
        if (isEventClosed) {
          return this.getClosedTitle(event.title);
        }
        return event.title;
      } else {
        // Multi-market event child row: show market question + closed status
        const title = isMarketClosed ? this.getClosedTitle(market.question) : market.question;
        
        // Find index of current market in the event's markets array
        const markets = event.markets || [];
        const marketIndex = markets.findIndex(m => m.id === market.id);
        const isLastMarket = marketIndex === markets.length - 1;
        
        // Create the tree structure connector using border techniques
        // const connector = `
        //   <div class="flex items-center">
        //     <div class="relative h-12 w-6 ">
        //       <div class="absolute h-full w-0.5 border-l border-gray-300 left-1"></div>
        //       <div class="absolute top-1/2 h-0.5 w-3 border-t border-gray-300 left-1"></div>
        //       ${!isLastMarket ? '<div class="absolute top-1/2 h-1/2 w-0.5 border-l border-gray-300 left-2"></div>' : ''}
        //     </div>
        //     <div class="flex-1">${title}</div>
        //   </div>
        // `;
        const connector = `
          <div class="flex items-center">
            <div class="relative h-12 w-6 ">
              
              <div class="absolute top-1/2 h-0.5 w-3 border-t border-gray-300 left-1"></div>
              ${!isLastMarket ? 
              '<div class="absolute h-full w-0.5 border-l border-gray-300 left-1"></div>' : 
              '<div class="absolute top-0 h-1/2 w-0.5 border-l border-gray-300 left-1"></div>'}
            </div>
            <div class="flex-1">${title}</div>
          </div>
        `;
          
        return connector;
      }
    },

    getColumnValue(item, key) {
      // Now using the explicit isParentRow flag
      switch (key) {
        /*
        case 'title':
          // This handles the title display for child rows (market question)
          // and for single-market events which don't have a separate parent row.
          const isClosed = item.event.closed || item.market?.closed;
          const titleClass = isClosed ? 'text-gray-500' : '';
          const closedTag = isClosed ? '<span class="text-red-500 ml-2">[CLOSED]</span>' : '';

          const linkHtml = `
            <a href="https://polymarket.com/event/${item.event.slug}" target="_blank" class="ml-1 opacity-0 group-hover:opacity-100 transition-opacity duration-150 flex-shrink-0" @click.stop tabindex="-1">
              <i class="fas fa-link text-blue-500 hover:text-blue-700"></i>
            </a>`;

          if (!item.event.nevuaMultipleMarkets) {
            // Single-market event: show event title + link + closed status
            return `
              <div class="flex items-center">
                <span class="mr-1 ${titleClass}">${item.event.title}</span>
                ${closedTag}
                ${linkHtml}
              </div>`;
          }

          // Multi-market event child row: show market question + link + connector lines + closed status

          // Styling for middle item
          const marketCount = item.event.markets.length;
          const marketQuestionHtml = `<span class="mr-1 ${titleClass}">${item.market.question}</span>`;

          if (item.market.id !== item.event.markets[marketCount - 1].id) {
            // top left + bottom left lines + market question + link + closed status
            return `<div class="w-2 h-1/2 ml-1 absolute left-0 top-0 border-b-2 border-l-2 "></div>
            <div class="w-2 h-1/2 ml-1 absolute left-0 bottom-0 border-l-2 "></div>
            <div class="ml-4 flex items-center">
              ${marketQuestionHtml}
              ${closedTag}
              ${linkHtml}
            </div>`;
          }

          // Styling for last item
          // bottom left line + market question + link + closed status
          return `<div class="w-3 h-1/2 ml-1 absolute left-0 top-0 border-b-2 border-l-2 "></div>
          <div class="ml-4 flex items-center">
            ${marketQuestionHtml}
            ${closedTag}
            ${linkHtml}
          </div>`;
        */
        case 'price': {
          if (item.isParentRow) {
            return ''
          }

          const price = item.market.outcomePrices ?
            (parseFloat(JSON.parse(item.market.outcomePrices)[0] || 0) * 100).toFixed(2) + '%' :
            'N/A';
          const outcomes = item.market.outcomes ? JSON.parse(item.market.outcomes) : ['Yes'];
          const firstOutcome = outcomes[0];

          return `
            <div class="text-left ml-2">
              <div class="font-normal text-xs">${price}</div>
              <div class="text-xs text-gray-500">(${firstOutcome})</div>
            </div>`;
        }
        case 'trend': {
          if (item.isParentRow) {
            return '<div class="h-[40px] w-[80px]"></div>';
          }

          // Extract clobTokenId
          const clobTokenId = item.market.clobTokenIds ? JSON.parse(item.market.clobTokenIds)[0] : null;
          
          // Return just the SVG content, not the wrapper div with the click handler
          return size(item.market.nevuaSVGLink) > 0 
            ? `<img src="https://img.nevua.markets${item.market.nevuaSVGLink}" class="h-[40px] w-[80px] hover:opacity-80"/>` 
            : this.generateSvgLinePlot(item.market);
        }

        case 'volume':
          if (item.isParentRow) {
            return this.formattedVolume(item.event.volume);
          }
          // if (item.event.markets.length > 1) {
          //   return `<div>${this.formattedVolume(item.market.volume)}</div>`
          // }
          // `<div class="text-[10px] text-gray-500">${this.formattedVolume(item.event.volume)}</div>`;
          return this.formattedVolume(item.market.volume);

        case 'createdAt':
          return `<div>${this.formatStringAsDate(item.market.createdAt)}</div>
                  <div class="text-xs text-gray-500">${this.formatDistanceToNow(item.market.createdAt)}</div>`;
        case 'endDate':
          if (item.isParentRow) {
            if (item.event.closed) {
              return `<div class="text-red-800">CLOSED</div>
                      <div class="text-xs text-gray-500">${this.formatDistanceToNow(item.event.closedTime)}</div>`;
            } else {
              return `<div>${this.formatStringAsDate(item.event.endDate)}</div>
                      <div class="text-xs text-gray-500">${this.formatDistanceToNow(item.event.endDate)}</div>`;
            }
          }
          if (item.market.closed) {
            return `<div class="text-red-800">CLOSED</div>
                    <div class="text-xs text-gray-500">${this.formatDistanceToNow(item.market.closedTime)}</div>`;
          } else {
            // sometimes the market endDate is undefined. This is usually when there are multiple markets in the event
            // and some have resolution date that is earlier than the event end date
            // In that case we use the event end date
            let endDate = item.market.endDate || item.event.endDate;
            return `<div>${this.formatStringAsDate(endDate)}</div>
                    <div class="text-xs text-gray-500">${this.formatDistanceToNow(endDate)}</div>`;
          }

        case 'provider':
          return `<a href="https://polymarket.com/event/${item.event.slug}" target="_blank" class="text-xs hover:underline " tabindex="-1">Polymarket <div class="fas fa-link"></div></a>`;
        case 'lastUpdated':
          return item.event.nevuaLastUpdatedTimestamp ?
            `<div class="text-xs text-gray-500">${this.formatDistanceToNow(item.event.nevuaLastUpdatedTimestamp * 1000)}</div>`
            : 'N/A';
        default:
          return '';
      }
    },

    generateSvgLinePlot(market) {
      console.log('generateSvgLinePlot for', market.id)
      const width = 80;
      const height = 40;
      const emptySvg = `<svg viewBox="0 0 ${width} ${height}" height="${height}" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg"></svg>`;
      return emptySvg;
      if (!timeseries || timeseries.length === 0) return emptySvg;

      const pValues = timeseries.map(entry => entry.p);

      // Check if all values are valid numbers
      if (!pValues.every(value => typeof value === 'number' && !isNaN(value))) {
        //console.warn('Invalid price values in timeseries:', pValues);
        return emptySvg;
      }

      const minY = Math.min(...pValues);
      const maxY = Math.max(...pValues);

      // Check if we have a valid range
      if (minY === maxY || !isFinite(minY) || !isFinite(maxY)) {
        //console.warn('Invalid min/max values:', { minY, maxY });
        return emptySvg;
      }

      const yRange = maxY - minY;
      const yValues = pValues.map(value => height - ((value - minY) / yRange) * height);

      // Validate yValues
      if (!yValues.every(value => isFinite(value))) {
        //console.warn('Invalid y-coordinates calculated:', yValues);
        return emptySvg;
      }

      const xStep = width / (pValues.length - 1);

      let pathSegments = [];
      yValues.forEach((y, i) => {
        if (i > 0) {
          const ratio = pValues[i];
          const r = Math.round((1 - ratio) * 0 + ratio * 255);
          const g = Math.round((1 - ratio) * 128 + ratio * 0);
          const b = Math.round((1 - ratio) * 255 + ratio * 0);
          const color = `rgba(${r}, ${g}, ${b}, 1)`;

          // Validate coordinates before adding path
          const x1 = (i - 1) * xStep;
          const y1 = yValues[i - 1];
          const x2 = i * xStep;
          const y2 = y;

          if (isFinite(x1) && isFinite(y1) && isFinite(x2) && isFinite(y2)) {
            pathSegments.push({
              path: `M ${x1.toFixed(2)} ${y1.toFixed(2)} L ${x2.toFixed(2)} ${y2.toFixed(2)}`,
              color: color
            });
          }
        }
      });

      if (pathSegments.length === 0) {
        return emptySvg;
      }

      const svgPaths = pathSegments.map(segment =>
        `<path d="${segment.path}" fill="none" stroke="${segment.color}" />`
      ).join('');

      const svg = `<svg viewBox="0 0 ${width} ${height}" height="${height}" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" 
                   class=" hover:opacity-80" 
                   @click="handleSvgClick('${timeseries[0]?.eventId}', '${timeseries[0]?.marketId}', '${timeseries[0]?.clobTokenId}')">
                   <rect x="0" y="0" width="${width}" height="${height}" fill="transparent" />
                   ${svgPaths}
                 </svg>`;
      return svg;
    },
    
    closeGraph() {
      this.activeGraph.show = false;
    },

    handleSvgClick(eventId, marketId, marketQuestion, eventSlug, clobTokenId, marketCreatedAt) {
      console.log('SVG clicked! Event ID:', eventId, 'Market ID:', marketId, 'Market Question:', marketQuestion, 'CLOB Token ID:', clobTokenId);

      this.activeGraph = {
        "eventId": eventId,
        "marketId": marketId,
        "marketCreatedAt": marketCreatedAt,
        "clobTokenId": clobTokenId,
        "eventSlug": eventSlug,
        "title": marketQuestion,
        "show": true
      };
    },



    toggleColumnVisibility(column) {
      column.visible = !column.visible;
    },

    toggleExpanded(eventId) {
      if (store.tableState.multiMarketEvents[eventId]) {
        store.tableState.multiMarketEvents[eventId].expanded = !store.tableState.multiMarketEvents[eventId].expanded;
      }
    },

    showContextMenu(event, eventData, market, isParentRow, selectedRowId) {
      event.preventDefault(); // Prevent default behavior

      // Get coordinates based on click target
      const rect = event.target.getBoundingClientRect();
      let x = rect.left + 10; // 200px is the min-width of the context menu
      let y = rect.top;

      // For right-click, use the click coordinates directly if they exist
      if (event.clientX !== undefined) {
        x = event.clientX + 10;
        y = event.clientY;
      }

      // Check if menu would go off-screen to the left
      if (x < 0) {
        x = rect.right; // Position to the right of the element instead
      }

      // Check if menu would go off-screen at the bottom
      const menuHeight = 250; // Approximate height of context menu
      if (y + menuHeight > window.innerHeight) {
        y = window.innerHeight - menuHeight - 10; // 10px padding from bottom
      }

      let isActive = false;
      if (isParentRow) {
        isActive = eventData.active && !eventData.closed;
      } else {
        isActive = market.active && !market.closed;
      }

      this.contextMenu = {
        show: true,
        x,
        y,
        event,
        selectedEvent: eventData,
        selectedMarket: isParentRow ? null : market,
        selectedRowId: selectedRowId,
        isParentRow,
        isBulkAction: false,
        isActive: isActive
      };
    },

    /*
      Watchlist Actions: Create, Delete, Add Items to existing, Remove Items from existing
      ------------------------------------------------------------
    */

    createNewWatchListWithSelectedItems(watchListName) {
      this.debouncedCreateNewWatchListWithSelectedItems(watchListName);
    },

    async addItemsToExistingWatchList(id) {
      const watchList = store.watchLists.find(item => item.id === id);

      if (!watchList) {
        showDialog({
          message: `Watchlist not found`,
          type: 'error',
          timeout: 3000
        });
        this.resetContextMenuAndSelectedRows();
        return;
      }
      let success = await updateWatchList(watchList.id, watchList);
      if (success) {
        const addedCount = addContextItemsToWatchList(watchList, this.contextMenu, this.selectedRows);
        showDialog({
          message: `Added ${addedCount} item${addedCount !== 1 ? 's' : ''} to ${watchList.name}`,
          type: 'success',
          timeout: 3000
        });
      } else {
        showDialog({
          message: `Failed to add items to watchlist`,
          type: 'error',
          timeout: 3000
        });
      }
      this.resetContextMenuAndSelectedRows();
    },

    async removeFromList() {
      // first clone watchlist to revert if error
      const watchListClone = { ...store.currentWatchList };
      const contextMenuClone = cloneDeep(this.contextMenu);
      const selectedRowsClone = cloneDeep(this.selectedRows);

      this.contextMenu.show = false;
      

      const { removedMarkets, removedEvents } = await removeContextItemsFromList(watchListClone, contextMenuClone, selectedRowsClone);

      // Format notification message
      const messageParts = [];
      if (removedMarkets > 0) {
        messageParts.push(`${removedMarkets} market${removedMarkets !== 1 ? 's' : ''}`);
      }
      if (removedEvents > 0) {
        messageParts.push(`${removedEvents} event${removedEvents !== 1 ? 's' : ''}`);
      }
      let success = await updateWatchList(watchListClone.id, watchListClone);
      if (success) {
        // Actually remove the items from the watchlist
        await removeContextItemsFromList(store.currentWatchList, contextMenuClone, selectedRowsClone);

        showDialog({
          message: `Removed ${messageParts.join(', ')} from ${watchListClone.name}`,
          type: 'success',
          timeout: 3000
        });
      } else {
        showDialog({
          message: `Failed to remove items from watchlist`,
          type: 'error',
          timeout: 3000
        });
      }

      this.resetContextMenuAndSelectedRows();
    },


    /*
      Add All Markets and toggle automatic add according to query
      ------------------------------------------------------------
    */
    getAutoFetchTooltipContent(event) {
      return `
        <div class="flex flex-col gap-2 p-2 font-sans">
          <div class="text-sm">New markets will automatically be added to this event <strong>only if they match the watchlist query</strong>.</div>
          <button class="bg-blue-100 hover:bg-blue-200 text-gray-600 text-sm px-3 py-1 rounded" @click="console.log('hi')">
            Track <strong> all </strong> markets for this event
          </button>
        </div>
      `;
    },

    async handleAddAllMarkets(selectedEventId) {
      this.isAddingAllMarkets = true;
      if (selectedEventId) {
        this.contextMenu.selectedEvent = store.tableState.events.find(e => e.id === selectedEventId);
      }
      const eventId = this.contextMenu.selectedEvent.id;
      const eventTitle = this.contextMenu.selectedEvent.title;

      try {
        // Initialize events object if it doesn't exist
        if (!store.currentWatchList.events) {
          store.currentWatchList.events = {};
        }

        // Initialize event object if it doesn't exist
        if (!store.currentWatchList.events[eventId]) {
          store.currentWatchList.events[eventId] = {
            autoFetch: true,
            markets: []
          };
        }

        // first, fetch all markets for this event. Passing an empty array of markets will fetch all markets
        // for this eventId
        const eventMap = {
          events: {
            [eventId]: {
              markets: []
            }
          }
        }
        // add header X-IMG-CACHE: true
        const response = await apiClient.post('https://api.nevua.markets/markets/token-prices-history', eventMap, {
          headers: { 'X-IMG-CACHE': 'true' }
        });
        if (response.data) {
          const eventIndex = store.tableState.events.findIndex(e => e.id === eventId);
          if (eventIndex !== -1) {
            store.tableState.events[eventIndex] = response.data[0];
          }

          // Set autoFetch to true and update the watchlist
          store.currentWatchList.events[eventId].autoFetch = true;
          store.currentWatchList.events[eventId].markets = response.data[0].markets.map(m => m.id);

          // Update settings through API
          await updateWatchList(store.currentWatchList.id, store.currentWatchList);

          showDialog({
            message: `Now tracking all markets for "${eventTitle}"`,
            type: 'success',
            timeout: 3000
          });
        }
      } catch (error) {
        Sentry.setExtra('method', 'handleAddAllMarkets');
        Sentry.captureException(error);
        showDialog({
          message: 'Failed to update market tracking. Please try again.',
          type: 'error',
          timeout: 3000
        });
      } finally {
        this.isAddingAllMarkets = false;
        this.resetContextMenuAndSelectedRows();
      }
    },

    async toggleAutomaticAdd() {
      if (store.currentWatchList) {
        store.currentWatchList.automaticallyAddMatchingEvents = !store.currentWatchList.automaticallyAddMatchingEvents;

        // Update the settings through the API
        let success = await updateWatchList(store.currentWatchList.id, {
          automaticallyAddMatchingEvents: store.currentWatchList.automaticallyAddMatchingEvents
        });
        if (!success) {
          store.currentWatchList.automaticallyAddMatchingEvents = !store.currentWatchList.automaticallyAddMatchingEvents;
          showDialog({
            message: `Failed to update watchlist`,
            type: 'error',
            timeout: 3000
          });
        }
      }
    },
    /*
      ------------------------------------------------------------
    */

    isRowSelected(event, market, isParentRow = false) {
      return this.selectedRows[this.getRowKey(event, market, isParentRow)] === true;
    },

    isParentPartiallySelected(event) {
      const childKeys = event.markets.map(m => this.getRowKey(event, m));
      const selectedChildren = childKeys.filter(key => this.selectedRows[key]);
      return selectedChildren.length > 0 && selectedChildren.length < childKeys.length;
    },

    handleRowSelection(e, event, market, isParentRow) {
      const isChecked = e.target.checked;

      if (isParentRow) {
        // Set the parent row selection
        this.selectedRows[this.getRowKey(event, market, true)] = isChecked;
        // Also select/deselect all child markets
        event.markets.forEach(m => {
          this.selectedRows[this.getRowKey(event, m)] = isChecked;
        });
      } else {
        this.selectedRows[this.getRowKey(event, market)] = isChecked;
      }
    },

    toggleSelectAll() {
      // If all or some are selected (check or minus), unselect all
      if (this.selectAllState === 'all' || this.selectAllState === 'some') {
        this.selectedRows = {};  // Clear all selections
      } else {
        // If none are selected, select all
        const newSelectedRows = {};
        this.flattenedEvents.forEach(({ event, market, isParentRow, rowKey }) => {
          newSelectedRows[rowKey] = true;
        });
        this.selectedRows = newSelectedRows;
      }
    },

    showBulkActionsMenu(e) {
      e.preventDefault();
      e.stopPropagation();

      // If menu is already shown with bulk actions, close it
      if (this.contextMenu.show && this.contextMenu.isBulkAction) {
        this.contextMenu.show = false;
        return;
      }

      //const rect = e.target.getBoundingClientRect();
      //let x = rect.left - 200; // 200px is the min-width of the context menu
      //let y = rect.top;

      const bulkActionsEl = e.target.closest('[data-bulk-actions]');
      if (!bulkActionsEl) {
        return;
      }
      const rect = bulkActionsEl.getBoundingClientRect();
      let x = rect.left;
      let y = rect.bottom;

      this.contextMenu = {
        show: true,
        isBulkAction: true,
        selectedEvent: null,
        selectedMarket: null,
        isParentRow: false,
        x,
        y,
        isActive: false
      };
    },

    areAllMarketsSelected(event) {
      return event.markets.every(market => this.selectedRows[this.getRowKey(event, market)]);
    },

    getColumnWidthClass(columnKey) {
      switch (columnKey) {
        case 'title': return 'w-72 min-w-72 max-w-72';
        case 'price': return 'w-16 min-w-16 max-w-16 truncate';
        case 'trend': return 'w-[80px] min-w-[80px] max-w-[80px]';
        // case 'autoFetch': return 'w-5 min-w-5 max-w-5';
        case 'volume': return 'w-20 min-w-20 max-w-20 truncate';
        case 'createdAt':
        case 'endDate': return 'w-20 min-w-20 max-w-20';
        case 'provider': return 'w-24 min-w-24 max-w-24';
        case 'lastUpdated': return 'w-20 min-w-20 max-w-20';
        default: return 'w-32 min-w-32 max-w-32';
      }
    },

    async toggleShowClosedItems() {
      if (size(store.currentWatchListId) > 0) {
        store.currentWatchList.tableSettings = store.currentWatchList.tableSettings || { showClosedItems: true, expandMultiMarketEventsTable: true, expandMultiMarketEventsTiles: false };

        store.currentWatchList.tableSettings.showClosedItems = !store.currentWatchList.tableSettings.showClosedItems;

        let success = await updateWatchList(store.currentWatchList.id, {
          tableSettings: store.currentWatchList.tableSettings
        });
        if (!success) {
          console.error('Failed to update watchlist');
        }
      }
    },

    async toggleExpandAll() {
      if (size(store.currentWatchListId) > 0) {
        // Initialize tableSettings if it doesn't exist
        store.currentWatchList.tableSettings = store.currentWatchList.tableSettings || { showClosedItems: true, expandMultiMarketEventsTable: true, expandMultiMarketEventsTiles: false };
        // Toggle the expandMultiMarketEventsTable setting
        store.currentWatchList.tableSettings.expandMultiMarketEventsTable = !store.currentWatchList.tableSettings.expandMultiMarketEventsTable;

        // Update all multimarket events' expanded state
        Object.keys(store.tableState.multiMarketEvents).forEach(eventId => {
          store.tableState.multiMarketEvents[eventId].expanded = store.currentWatchList.tableSettings.expandMultiMarketEventsTable;
        });

        // Update settings through API
        let success = await updateWatchList(store.currentWatchList.id, {
          tableSettings: store.currentWatchList.tableSettings
        });
        if (!success) {
          console.error('Failed to update watchlist');
        }
      }
    },

    resetContextMenuAndSelectedRows() {
      this.contextMenu = {
        show: false,
        x: 0,
        y: 0,
        event: null,
        selectedEvent: null,
        selectedMarket: null,
        selectedRowId: null,
        isParentRow: false,
        isBulkAction: false,
        isActive: false
      };
      this.selectedRows = {};
      this.eventsToCreateAlertFor = {};
    },

    closeSubscriptionDeleteModal() {
      store.isSubscriptionDeleteModalOpen = false;
      this.handleCloseSubscriptionsDialog();
    },

    async confirmSubscriptionDelete() {
      try {
        if (!store.subscriptionIdToDelete) {
          throw new Error('No subscription to delete');
        }

        const response = await apiClient.delete(`https://api.nevua.markets/subscriptions/${store.subscriptionIdToDelete}`);
        if (response.status === 200) {
          showDialog({
            message: 'Alert deleted successfully',
            type: 'success',
            timeout: 3000
          });

          // Update subscriptions for watchlist
          if (size(store.currentWatchListId) > 0) {
            deleteSubscriptionFromGlobalStateAndTableState(store.subscriptionIdToDelete, store.currentWatchListId);
          }
        }
      } catch (error) {
        Sentry.setExtra('method', 'confirmSubscriptionDelete');
        Sentry.captureException(error);
        showDialog({
          message: 'Failed to delete alert',
          type: 'error',
          timeout: 3000
        });
      } finally {
        this.closeSubscriptionDeleteModal();
      }
    },

    // Handles emited delete event from SubscriptionsDialogContent with subscriptionId
    // Delete happens in the modal
    handleSubscriptionDelete(subscriptionId) {
      store.subscriptionIdToDelete = subscriptionId;
      store.isSubscriptionDeleteModalOpen = true;
    },

    /*
      Subscription Create
    */
    getSubscriptionTitle(subscription) {
      switch (subscription.subscriptionScope) {
        case SubscriptionScope.WATCHLIST:
          return this.getWatchlistName(subscription.watchlistId);
        case SubscriptionScope.EVENT:
          return subscription.eventTitle;
        case SubscriptionScope.MARKET:
          return subscription.marketQuestion;
        default:
          return 'N/A';
      }
    },

    getWatchlistName(watchlistId) {
      const result = store.watchLists?.find(watchlist => watchlist.id === watchlistId)?.name;
      return result || 'Unknown watchlist name';
    },

    /*
      List alerts and default to a 'create alert' tab
    */
    listAlertsAndCreateAlert({ scope, event, market, watchlistId = null }) {
      store.listAlertsForEventId = event?.id;
      store.listAlertsForMarketId = market?.id;
      store.listAlertsForWatchlistId = watchlistId;
      store.showAlertListTabFirst = true;
      store.showSubscriptionsDialog = false;

      this.$nextTick(() => {
        this.handleCreateAlert(scope, event, market);
      });
    },

    handleGraphAlert(eventId, marketId, price) {
      store.subscriptionPrice = price;
      store.showSubscriptionsDialog = false;
      store.showAlertListTabFirst = false;

      // find event and market in store.tableState.events
      const event = store.tableState.events.find(e => e.id === eventId);
      const market = event.markets.find(m => m.id === marketId);

      if (!event || !market) {
        console.log('Event or market not found');
        return;
      }

      this.$nextTick(() => {
        this.handleCreateAlert(SubscriptionScope.MARKET, event, market, price);
      });
    },

    handleCreateAlertFromContextMenu(scope = SubscriptionScope.WATCHLIST, event, market) {
      store.showSubscriptionsDialog = false;
      store.showAlertListTabFirst = false;

      if (this.contextMenu?.show) {
        this.contextMenu.show = false;
      }

      this.$nextTick(() => {
        this.handleCreateAlert(scope, this.contextMenu?.selectedEvent, this.contextMenu?.selectedMarket);
      });
    },

    // Pass context through props to SubscriptionsDialogContent and show dialog
    // Actual creation of alert in API happens in SubscriptionsDialogContent


    /*
      Subscription Edit
    */
    // Handles emited edit event from SubscriptionsDialogContent with subscription
    // Basically sets props for SubscriptionsDialogContent and shows dialog
    // Actual edit and call to API is handled in SubscriptionsDialogContent
    handleSubscriptionEdit(subscription) {
      store.subscriptionToEdit = subscription;
      store.showAlertListTabFirst = false;
      store.subscriptionScope = subscription.subscriptionScope;
      store.subscriptionTargetTitle = this.getSubscriptionTitle(subscription);

      // We don't pass eventsToCreateAlertFor since we are editing the alert
      // this.eventsToCreateAlertFor = subscription.events;

      store.showSubscriptionsDialog = true;
    },

    /*
      Subscription Dialog Close
    */
    // Handles emited close event from SubscriptionsDialogContent, resets props
    handleCloseSubscriptionsDialog() {
      this.resetContextMenuAndSelectedRows();
      clearSubscriptionDialogState();
    },

    getSearchBarHeight() {
      if (this.$refs.searchBar) {
        const height = this.$refs.searchBar.$el.getBoundingClientRect().height;
        console.log('SearchBar height:', height);
        return height; // mb-4 from SearchBar
      }
      return 0;
    },

    getMainContentHeight() {
      if (this.$refs.mainContent && this.$refs.mainContent.$el) {
        const height = this.$refs.mainContent.$el.getBoundingClientRect().height;
        console.log('MainContent height:', height);
        return height;
      }
      return 0;
    },

    getSubscriptionsDialogHeight() {
      return this.dialogHeight;
    },
    
    updateDialogHeight() {
      if (this.$refs.mainContent && this.$refs.mainContent.$el) {
        const contentHeight = this.$refs.mainContent.$el.getBoundingClientRect().height;
        const searchBarHeight = this.getSearchBarHeight();
        this.dialogHeight = contentHeight - searchBarHeight;
        console.log('Dialog height:', this.dialogHeight);
      }
    },
  },
};
</script>

<style scoped>
.tab-common {
  @apply shrink-0 border-b-2 px-2 pb-2 text-base font-medium;
}

.tab-selected {
  @apply tab-common border-gray-500 text-sky-600;
}

.tab-unselected {
  @apply tab-common border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700;
}

.th-class {
  @apply text-left text-sm font-medium text-gray-500 uppercase;
  /* tracking-wider */
}

.absolute {
  position: absolute;
}

/* Only keeping minimal required CSS that can't be handled by Tailwind */
thead,
tbody tr {
  /* display: table;
  width: 100%;
  table-layout: fixed; */
}

thead {
  /* width: calc(100% - 8px);  Subtract scrollbar width */
}

/* @apply !w-3 !min-w-3 !max-w-3 px-2; */
.action-col {
  @apply !w-5 !min-w-5 !max-w-5;
  /* width: 14px !important;
  min-width: 14px !important;
  max-width: 14px !important;
  flex-shrink: 0 !important;
  flex-grow: 0 !important; */
}
.action-col-last {
  @apply !w-5 !min-w-5 !max-w-5;
  /* width: 14px !important;
  min-width: 14px !important;
  max-width: 14px !important;
  flex-shrink: 0 !important;
  flex-grow: 0 !important; */
}
</style>
